var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layOut"},[_c('headers',{attrs:{"token":_vm.token,"activeItem":this.activeItem}}),_c('sideCar',{staticClass:"sideCar",attrs:{"token":_vm.token}}),_c('contents',{ref:"main",staticClass:"main"}),(_vm.Footer)?_c('layoutFooter',{staticClass:"footer"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }